import * as yup from 'yup';

export const schema = yup.object({
    // Validaciones Cliente
    nombre: yup.string().required('El nombre es requerido'),
    dni: yup.string().required('El DNI es requerido'),
    telefono: yup.string().required('El teléfono es requerido'),
    // Opcional: hay alumnos sin correo. Sin él no hay portal ni avisos.
    email: yup.string().trim().email('Email inválido'),
    // Opcional: es un dato útil (edad, contratos de menores) pero no debe impedir
    // dar de alta a un cliente. Si se rellena, se sigue validando el rango.
    fechaNacimiento: yup.string()
        .test('fecha-valida', 'La fecha de nacimiento no es válida', function(value) {
            if (!value) return true;
            const fecha = new Date(value);
            const hoy = new Date();
            const anioMinimo = new Date('1900-01-01');
            if (fecha > hoy) {
                return this.createError({ message: 'La fecha no puede ser futura' });
            }
            if (fecha < anioMinimo) {
                return this.createError({ message: 'La fecha no puede ser anterior a 1900' });
            }
            return true;
        }),
    
    // Validaciones Suscripción
    tipoPago: yup.string().required('El tipo de pago es requerido'),
    importeSuscripcion: yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required('El importe es requerido')
        .min(0, 'El importe debe ser mayor o igual a 0'),
    descuento: yup.number()
        .min(0, 'El descuento debe ser mayor o igual a 0')
        .transform((value) => (isNaN(value) ? undefined : value)),
    iban: yup.string(),

    // Validaciones del Pagador
    pagador: yup.object({
        nombre: yup.string()
            .when('tipoPago', {
                is: 'Pagador - No Cliente',
                then: (schema) => schema.required('El nombre del pagador es requerido'),
            }),
        DNI: yup.string()
            .when('tipoPago', {
                is: 'Pagador - No Cliente',
                then: (schema) => schema.required('El DNI del pagador es requerido'),
            }),
        IBAN: yup.string()
            .when('tipoPago', {
                is: 'Pagador - No Cliente',
                then: (schema) => schema.required('El IBAN del pagador es requerido'),
            }),
        telefono: yup.string()
            .when('tipoPago', {
                is: 'Pagador - No Cliente',
                then: (schema) => schema.required('El teléfono del pagador es requerido'),
            }),
        email: yup.string()
            .email('Email del pagador inválido')
    }).optional(),
}).required();